import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import type MatchParticipantModel from 'tio-common/models/match-participant';
import type MatchPaymentModel from 'tio-common/models/match-payment';
import type EmployeeModel from 'tio-common/models/employee';

export interface AuthenticatedSyfRouteModel {
  matchParticipant: MatchParticipantModel;
  matchPayments: MatchPaymentModel[];
}

export default class AuthenticatedSyfRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model(): Promise<AuthenticatedSyfRouteModel | null> {
    const employee = await this.store.findRecord<EmployeeModel>(
      'employee',
      // @ts-expect-error: fix model types
      this.sessionContext.currentEmployee.id,
      {
        include: [
          'match-participant.email-address',
          'match-participant.match-plan',
          'match-participant.person.account-transactions',
        ].join(','),
        reload: true,
      }
    );

    const matchParticipant = employee.matchParticipant;
    if (!matchParticipant) {
      return null;
    }

    // Query match-payments separately with proper filter to exclude discarded
    const matchPayments = await this.store.query<MatchPaymentModel>('match-payment', {
      filter: {
        'match-participant': matchParticipant.id,
        'include-discarded': false,
      },
      include: 'account-transaction.financial-institution',
      sort: '-transaction-date',
      page: { limit: 100 },
    });

    return {
      matchParticipant,
      matchPayments: matchPayments.slice(),
    };
  }
}
